import React from 'react'
import { BsLinkedin, BsInstagram, BsGithub } from "react-icons/bs"
const SocialMedia = () =>
{
  return (
    <div className='app__social'>
        <a href='https://www.linkedin.com/in/el-hadji-rawane-meissa-sow-b870051a5/' target="_blank">
            <BsLinkedin />
        </a>
        <a href='https://www.instagram.com/rawane_sow_/?hl=fr' target="_blank">
            <BsInstagram />
        </a>
        <a href='https://github.com/RawaneG' target="_blank">
            <BsGithub />
        </a>
    </div>
  )
}

export default SocialMedia